import { ColorTypes } from '@genial/design-tokens';

import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export interface TransactionFields {
  label: string;
  key: string;
}

export const tableHeaders: TableHeadItemRecurse[] = [
  { title: 'Data Solicitação', flex: 1.5, orderValue: 'requestDate' },
  { title: 'Data Liquidação', orderValue: 'settlementDate' },
  { title: 'Cliente', flex: 1.5, orderValue: 'clientName' },
  { title: 'Produto', orderValue: 'product' },
  { title: 'Tipo', orderValue: 'type' },
  { title: 'Valor', orderValue: 'value' },
  { title: 'Ativo', flex: 1.5, orderValue: 'asset' },
  { title: 'Status', orderValue: 'status' },
];

export const fieldsMobileTablet: TransactionFields[] = [
  { label: 'Data Solicitação', key: 'requestDate' },
  { label: 'Data Liquidação', key: 'settlementDate' },
  { label: 'Cliente', key: 'clientName' },
  { label: 'Produto', key: 'product' },
  { label: 'Tipo', key: 'type' },
  { label: 'Valor', key: 'value' },
  { label: 'Ativo', key: 'asset' },
  { label: 'Status', key: 'status' },
];

export const getCodedColor = (value: number): ColorTypes.Option => {
  if (value > 0) {
    return 'feedback.success.default';
  } else if (value < 0) {
    return 'feedback.error.default';
  } else {
    return 'neutral.darkest';
  }
};
